import React from "react";
import loadingLogo from "images/BlogFreeRecipeLogo.png";

const BadgeGuide = ({ badges = [], loading = false }) => {
  const uniqueBadges = new Map();

  (Array.isArray(badges) ? badges : []).forEach((badge) => {
    const name = badge?.name?.trim();
    if (!name) return;

    const key = name.toLowerCase();
    const existing = uniqueBadges.get(key);

    if (!existing || (!existing.image && badge.image)) {
      uniqueBadges.set(key, { ...badge, name });
    }
  });

  const sortedBadges = [...uniqueBadges.values()].sort((a, b) =>
    a.name.localeCompare(b.name),
  );

  if (loading) {
    return (
      <div className="BadgeGuide-Loading" role="status">
        <img
          className="loading BadgeGuide-LoadingLogo"
          src={loadingLogo}
          alt="Loading badges…"
        />
      </div>
    );
  }

  return (
    <div className="BadgeGuide">
      {sortedBadges.length === 0 ? (
        <p>No badges available yet.</p>
      ) : (
        <ul className="BadgeGuide-List" aria-label="Badge meanings" role="list">
          {sortedBadges.map((badge) => (
            <li key={badge.name.toLowerCase()} className="BadgeGuide-Item">
              {badge.image && (
                <img
                  className="BadgeGuide-Image"
                  src={badge.image}
                  alt=""
                  width={56}
                  height={56}
                  loading="lazy"
                />
              )}

              <span className="BadgeGuide-Name">{badge.name}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default BadgeGuide;
